import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { HIDE_HEADER_FROM_ROUTES } from "../constants/mainLayout";
import { getRouteAfterRemovingQueryParams } from '../utils/routeHelpers';
import useRoute from '../hooks/useRoute';

const useLayout = () => {

    const location = useLocation();
    const { getRoute } = useRoute();

    const hideDefaultHeader: boolean = useMemo(() => {
        return HIDE_HEADER_FROM_ROUTES.map(route => {
            return (getRouteAfterRemovingQueryParams(getRoute(route)))
        }).includes(location.pathname) ||
            location.pathname.includes('/content/') || location.pathname.includes('/overview') || location.pathname.includes('/crm') || location.pathname.includes('/reports') //To hide header from collection page (in different modes) and content edit pages
    }, [location.pathname]);

    return { hideDefaultHeader };
};

export default useLayout;
